export enum StatusBadgeColourScheme {
    Green,
    Red,
    Blue2,
    activeBlue,
    grey,
    warningOrange,
    saOrange
}
